import { fabric } from 'fabric';
import { round } from 'shared/utils/round';
import type { GradientStop } from './linear-gradient';

/** Меньше двух точек — уже не градиент: удаление последней пары запрещено в обоих редакторах. */
export const MIN_GRADIENT_STOPS = 2;

/** Угол в диапазоне [0, 360): `-45` → `315`, `360` → `0`. */
export function normalizeGradientAngle(angle: number): number {
  return ((angle % 360) + 360) % 360;
}

/** Новая точка — посередине самого широкого промежутка, цветом левой соседки: вид градиента не меняется. */
export function withStopInWidestGap(stops: GradientStop[]): GradientStop[] {
  let widest = 0;
  for (let i = 1; i < stops.length; i++) {
    if (stops[i].offset - stops[i - 1].offset > stops[widest + 1].offset - stops[widest].offset) widest = i - 1;
  }
  const left = stops[widest];
  const right = stops[widest + 1] ?? left;
  const added = { offset: round((left.offset + right.offset) / 2, 4), color: left.color };
  return [...stops.slice(0, widest + 1), added, ...stops.slice(widest + 1)];
}

/** Цвет точки, разложенный для поля `<input type="color">` (только `#rrggbb`) и отдельной непрозрачности 0–1. */
export interface StopColorParts {
  hex: string;
  alpha: number;
}

/** Любой CSS-цвет точки (`rgba(…)`, `#RRGGBBAA`, `#rgb`) → `#rrggbb` + непрозрачность. */
export function splitStopColor(color: string): StopColorParts {
  const parsed = new fabric.Color(color);
  return { hex: '#' + parsed.toHex().toLowerCase(), alpha: parsed.getAlpha() };
}

/**
 * Обратно в цвет точки: непрозрачный — `#rrggbb` как есть, иначе `#RRGGBBAA` (так же пишет
 * `defaultLinearGradient`, так хранит каталог табло).
 */
export function joinStopColor(hex: string, alpha: number): string {
  const clamped = Math.min(Math.max(alpha, 0), 1);
  if (clamped === 1) return hex;
  const color = new fabric.Color(hex);
  color.setAlpha(clamped);
  return '#' + color.toHexa();
}
